export const PATHS = {
  HOME: '/', //done
  CONTACT: '/contact-us/', //done not links found
  REQUEST_A_DEMO: '/request-a-demo/', //done not links found
  DEMOHOME: '/demohome/', // done not links found
  PRICING: '/pricing/', // done
  COWBOY: '/cowboy/', // done not links found
  LAUNCH: '/launch/', // done not links found
  VIDEO_SCENARIOS: '/video-scenarios/', // done 
  VIDEO: '/video/', // done
  COVID_SUPPORT: '/covid-support/',  // done not links found
  DEMO: '/demo/', // done not links found
  INDEX_OLD: '/index-old/', // done not links found
  PRICING_V2: '/pricing-v2/', // done not links found


  //Company
  ABOUT: '/company/about/', // done
  JOBS: '/company/jobs/', // done not links found 
  INVESTORS: '/company/investors/', // done
  PRESS: '/company/press/', // done
  CONTACTUS: '/company/contactus/', // done
  MEDIA: '/company/media/', // done
  LEADERSHIP: '/company/leadership', //done

  //Legal
  PRIVACY_POLICY: '/legal/privacy-policy/', // done
  
  //Resources 
  RESOURCES: '/resources/', // done
  CUSTOMER_STORIES: '/resources/customer-stories/', // done
  REMY_STORY: '/resources/customer-stories/remy-cointreau/', // done
  EVEN_STORY: '/resources/customer-stories/even-financial/', // done
  INVISION_STORY: '/resources/customer-stories/invision/', // done
  SHOWBIE_STORY: '/resources/customer-stories/showbie/', // done
  CHARTING_BETTER_WORKPLACES_2020: '/resources/guides-ebooks/charting-better-workplaces/2020/', // done
  FAIR_EQUITABLE_COMPENSATION: '/resources/guides-ebooks/fair-equitable-compensation/', // done
  RETURN_TO_WORK: '/resources/guides-ebooks/return-to-work/', // done
  REMOTE_WORK_SALARIES: '/resources/guides-ebooks/remote-work-salaries/', // done
  PLANNING_FOR_2021: '/resources/webinars/planning-for-2021/', // done
  DEI_REPORTING: '/resources/guides-ebooks/dei-reporting/',
  STARTUPS_INTENTIONAL_GROWTH: '/resources/guides-ebooks/startups-intentional-growth/',
  HEADCOUNT_PLANNING_GUIDE: '/resources/guides-ebooks/headcount-planning-guide/',
  STARTUP_PEOPLE_LEADER_CHECKLIST: '/resources/guides-ebooks/startup-people-leader-checklist/',
  CHARTING_BETTER_GALAXIES: '/resources/guides-ebooks/charting-better-galaxies/',
  PEOPLE_PIONEERS_2022: '/resources/guides-ebooks/2022-people-pioneers/',
  BUILDING_BLOCKS_PAY_EQUITY: '/resources/guides-ebooks/4-building-blocks-pay-equity',
  KEYS_MAINTAINING_SCALE_MASSIVE_GROWTH: '/resources/guides-ebooks/3-keys-maintaining-scale-massive-growth/',
  VIDEOS: '/resources/videos/',

  //Platform
  OVERVIEW: '/platform/overview/', // done
  WHY_CHARTHOP: '/platform/why-charthop/', // done
  DEI: '/platform/dei/', // done
  INTEGRATIONS: '/platform/integrations/', // done
  BAMBOOHR: '/platform/integrations/bamboohr/', // done
  SAPLING: '/platform/integrations/sapling/', // done
  WORKDAY: '/platform/integrations/workday/', // done
  SAP_SUCCESSFACTORS: '/platform/integrations/sap-successfactors/', // done
  WORKLIFE: '/platform/integrations/worklife/', // done not links found
  GUSTO: '/platform/integrations/gusto/', // done
  JUSTWORKS: '/platform/integrations/justworks/', // done
  ADP: '/platform/integrations/adp/', // done not links found
  NAMELY: '/platform/integrations/namely/', // done
  SEQUOIA: '/platform/integrations/sequoia/', // done
  TRINET: '/platform/integrations/trinet/', // done
  RIPPLING: '/platform/integrations/rippling/', // done
  ZENEFITS: '/platform/integrations/zenefits/', // done
  PAYLOCITY: '/platform/integrations/paylocity/', // done
  GREENHOUSE: '/platform/integrations/greenhouse/', // done no links found
  SHRM: '/platform/integrations/shrm/', // done no links found
  ULTIPRO: '/platform/integrations/ultipro/', // done no links found
  HUMAANS: '/platform/integrations/humaans/', // done
  LEVER: '/platform/integrations/lever/', // done
  JOBVITE: '/platform/integrations/jobvite', // done
  CONNECT: '/platform/connect/', // done
  SECURITY: '/platform/security/', // done
  ORG_CHART: '/platform/org-chart/', // done
  REPORTING: '/platform/reporting/', // done
  PLANNING: '/platform/planning/', // done
  COMPENSATION: '/platform/compensation/', // done
  PERFORMANCE: '/platform/performance/', // done
  EMPLOYEE_EXP: '/platform/employee-experience/', // done

  //Blog
  BLOG: '/blog/', // done
  BLOG_BEST_PRACTICES: '/blog/best-practices/', // done no links found
  BLOG_COMPANY_UPDATES: '/blog/company-updates/', // done no links found
  BLOG_PRODUCT_UPDATES: '/blog/product-updates/', // done no links found
  BLOG_DEI: '/blog/dei/', // done no links found
  BLOG_ORG_CHART: '/blog/org-chart/', // done no links found
  BLOG_BEST_PRACTICES_STARBUST: '/blog/best-practices/how-starburst-fueled-hypergrowth/'
}
